/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_4Inputs */

const en_pc_cmp_adv_4 = /** @type {(inputs: Pc_Cmp_Adv_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source code you can audit, fork or deploy across a company for free.`)
};

const zh_pc_cmp_adv_4 = /** @type {(inputs: Pc_Cmp_Adv_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源代码可审计、可派生，也可在全公司免费部署。`)
};

/**
* | output |
* | --- |
* | "Open source code you can audit, fork or deploy across a company for free." |
*
* @param {Pc_Cmp_Adv_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_4 = /** @type {((inputs?: Pc_Cmp_Adv_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_4(inputs)
	return zh_pc_cmp_adv_4(inputs)
});
export { pc_cmp_adv_4 as "pc.cmp.adv.4" }